import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Stepper from '@mui/material/Stepper';
import * as React from 'react';
import zeplinColor from '../../../theme/Color';

export default function CustomStepper({
  activeStep,
  setActiveStep,
  disabled = true,
  steps = ['Deal details', 'Price book', 'Product'],
  completed,
  style,
}: {
  activeStep: number;
  steps?: string[];
  disabled?: boolean;
  style?: React.CSSProperties | SxProps;
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  setCompleted: React.Dispatch<
    React.SetStateAction<{
      [k: number]: boolean;
    }>
  >;
  completed: {
    [k: number]: boolean;
  };
}) {
  const handleStep = (step: number) => () => {
    setActiveStep(step);
  };

  return (
    <Box sx={{ ...(style ? style : { width: '100%', padding: '24px 16px 10px 16px' }) }}>
      <Stepper
        activeStep={activeStep}
        sx={{ '& .MuiStepConnector-line': { borderColor: zeplinColor.Neutral5 } }}
      >
        {steps.map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepButton
              disabled={disabled}
              sx={{
                '& .MuiSvgIcon-root': { width: '32px', height: '32px' },
                '& .MuiStepIcon-root.Mui-active': { color: zeplinColor.BasicBlack },
                '& .MuiStepIcon-root': {
                  color: index < activeStep ? zeplinColor.Success : zeplinColor.Neutral5,
                },
                '& .MuiStepLabel-label.Mui-active': {
                  fontWeight: 520,
                  color: zeplinColor.BasicBlack,
                  fontSize: '14px',
                },
                '& .MuiStepLabel-label': {
                  fontWeight: 520,
                  color: zeplinColor.Neutral8,
                  fontSize: '14px',
                },
              }}
              onClick={!(label === 'Products') ? handleStep(index) : undefined}
            >
              {label}
            </StepButton>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
